if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    document.querySelectorAll('.js-form-footer').forEach(function(element){
        element.addEventListener('click', function(e){
            e.preventDefault();
            var top_ele = $('#form-footer').offset().top;
            $('html,body').animate({scrollTop:top_ele-100},2000).delay(1200);
        })
    })

    $('.sym-slides').slick({
        accessibility: true
    });
    

    $('[data-fancybox]').fancybox({
        toolbar  : false,
        smallBtn : true
    });


    function clickForm(){
        if(document.querySelector('.js-form-footer')){
            document.querySelector('.js-form-footer').addEventListener('click', function(){
                var top_ele = $('#form-footer').offset().top;
                $('html,body').animate({scrollTop:top_ele-100},2000).delay(1200);
            })
        }
    }
    

    $('.text-modules-wrapper .text-modules').addClass('animate-fade top');

    $('.js-open-menu').click(function(){
        $('.navigation.overlay').addClass('show');
    });

    $('.close-menu').click(function(){
        $('.navigation.overlay').removeClass('show');
    });

    //Toggle open/close on tap
	$('.navigation li a').off('click').on('click', function (event) {
        if ($(this).parent().children('.sub-sub-menu').length > 0) {
            event.preventDefault()

            if ($(this).next().hasClass('menu-open')) {
                $(this).closest('.inner').removeClass('open')
                $('.navigation ul li').removeClass('item-open')
                $(this).parent().addClass('item-open')
                $(this)
                    .next()
                    .slideUp(300, function () {
                        if ($('.navigation ul li a').hasClass('active')) {
                            $('.item-open').get(0).scrollIntoView(false)
                        }
                    })
                    .removeClass('menu-open')
            } else {
                $(this).closest('.inner').addClass('open')
                $('.navigation ul li').removeClass('item-open')
                $(this).parent().addClass('item-open')
                $('.sub-sub-menu.menu-open').slideUp(300).removeClass('menu-open')
                $(this)
                    .next()
                    .addClass('menu-open')
                    .slideDown(300, function () {
                        if ($('.navigation ul li a').hasClass('active')) {
                            $('.item-open').get(0).scrollIntoView(false)
                        }
                    })
            }
        }
    });

    let svg = document.querySelectorAll('svg');
    svg.forEach(function(element){
        element.removeAttribute('id');
    });

    if(document.querySelector('.capacity-chart')){
        let itemsTd = document.querySelectorAll('.capacity-chart__table .td-item');
        itemsTd.forEach((item)=>{
            item.removeAttribute("style");
        })
    }

})();